/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ICategory } from "web/types/Category";
import { ICategoryCount } from "web/types/CategoryCount";
import {
  ICategoryFunctionalityMenuItem,
  IFunctionalityMenuItem,
  IUrlFunctionalityMenuItem,
  IUrlMenuItem,
  MenuItem,
  MenuItemType,
} from "web/types/Menu";

import checkHasSubcategory from "./checkHasSubcategory";
import handleCategoryFunctionalityWebview from "./handleCategoryFunctionalityWebview";
import handleFunctionalityMenuItem from "./handleFunctionalityMenuItem";
import handleUrlFunctionalityMenuItem from "./handleUrlFunctionalityMenuItem";
import handleUrlMenuItem from "./handleUrlMenuItem";
import redirectToCategory from "./redirectToCategory";
import type { MenuItemContext, ProcessedMenuItem, SubmenuItem } from "./types";

const handleMenuItemWebview = (
  menuItem: MenuItem,
  context: MenuItemContext,
  categoriesData: ICategory[],
  categoriesTree: string[] | undefined,
  categoriesSizes: ICategoryCount[]
): ProcessedMenuItem | null => {
  const { type } = menuItem;
  switch (type) {
    case MenuItemType.URL:
      return handleUrlMenuItem(menuItem as IUrlMenuItem, context.isEn);

    case MenuItemType.FUNCTIONALITY:
      return handleFunctionalityMenuItem(
        menuItem as IFunctionalityMenuItem,
        context
      );

    case MenuItemType.URL_FUNCTIONALITY:
      return handleUrlFunctionalityMenuItem(
        menuItem as IUrlFunctionalityMenuItem,
        context
      );

    case MenuItemType.CATEGORY_FUNCTIONALITY: {
      const result = handleCategoryFunctionalityWebview({
        menuItem: menuItem as ICategoryFunctionalityMenuItem,
        hasEnabledAnySubscriptions: context.hasEnabledAnySubscriptions,
        subscriptionConfig: context.subscriptionConfig,
        enableMobilePreview: context.enableMobilePreview,
        enableNewSubscriptionUI: context.enableNewSubscriptionUI,
      });

      if (result) {
        return {
          type: MenuItemType.CATEGORY_FUNCTIONALITY,
          code: menuItem.code,
          title: result.title,
          submenu: result.submenu,
        };
      }
      return null;
    }

    case MenuItemType.TILES: {
      const submenu = menuItem.submenu
        ? menuItem.submenu
            .map((item) => {
              if (item.type === MenuItemType.CATEGORY) {
                const category = categoriesData.find(
                  (category) => +category.id === +item.id_category
                );
                if (category) {
                  return {
                    ...item,
                    id: category.id,
                    name: category.name,
                    hasSubcategory: checkHasSubcategory(
                      category.id,
                      categoriesTree
                    ),
                    hasProducts: !!categoriesSizes.find(
                      (x) => +x.id === +category.id
                    ),
                    redirectUrl: redirectToCategory(category),
                  };
                }
              }

              if (item.type === MenuItemType.FUNCTIONALITY) {
                return handleFunctionalityMenuItem(
                  item as IFunctionalityMenuItem,
                  context
                );
              }

              if (item.type === MenuItemType.URL_FUNCTIONALITY) {
                return handleUrlFunctionalityMenuItem(
                  item as IUrlFunctionalityMenuItem,
                  context
                );
              }

              if (item.type === MenuItemType.URL) {
                return handleUrlMenuItem(item as IUrlMenuItem, context.isEn);
              }

              return item;
            })
            .filter(Boolean)
        : [];

      return submenu.length > 0
        ? {
            ...menuItem,
            submenu: submenu as SubmenuItem[],
          }
        : null;
    }

    default:
      return null;
  }
};

export default handleMenuItemWebview;
